import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InfoIcon from "@material-ui/icons/Info";
import EditSponsorElement from "../EditSponsorElement";

export default class EditPouleDialog extends React.Component {
  componentDidMount = () => {
    // update possbily changed scoreType
    if (
      this.props.bracket &&
      this.props.bracket.scoreType &&
      this.props.bracket.scoreType !== this.props.scoreType
    ) {
      this.props.setScoreType(this.props.bracket.scoreType);
    }

    if (!this.props.bracket) {
      this.props.setScoreType(
        ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
          this.props.division.id
        ] || {})[this.props.fase] || "default"
      );
    }
  };
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.bracket
            ? languages.structure.editBracket
            : languages.structure.addBracket}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            {this.props.bracket && (
              <TextField
                autoFocus
                margin="normal"
                label={languages.general.name}
                value={this.props.name}
                name="name"
                onChange={this.props.handleChange}
                type="text"
                fullWidth
              />
            )}

            {!this.props.bracket && !this.props.subBracketTo && (
              <FormControl style={{ marginTop: 20, width: "100%" }}>
                <InputLabel htmlFor="bracket-size">
                  {languages.formatString(
                    languages.structure.numTeams,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playersLow
                      : languages.tournament.teamsLow
                  )}
                </InputLabel>
                <Select
                  value={this.props.size}
                  onChange={this.props.handleSizeChange}
                  inputProps={{
                    name: "size",
                    id: "bracket-size",
                  }}
                  style={{ width: "100%" }}
                >
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={8}>8</MenuItem>
                  <MenuItem value={16}>16</MenuItem>
                  <MenuItem value={32}>32</MenuItem>
                  <MenuItem value={64}>64</MenuItem>
                </Select>
              </FormControl>
            )}

            {Object.keys(this.props.tournament.scoringTypes || {}).length >
              0 && (
              <FormControl style={{ width: "100%", marginTop: 20 }}>
                <InputLabel style={{ width: "100%" }} htmlFor="scoreType">
                  {languages.structure.scoring}
                </InputLabel>
                <Select
                  style={{ maxWidth: "100%" }}
                  value={this.props.scoreType}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "scoreType",
                    id: "scoreType",
                  }}
                >
                  {this.props.showMultiple && (
                    <MenuItem disabled value={"multiple"}>
                      {languages.structure.multiple2}
                    </MenuItem>
                  )}
                  <MenuItem value={"default"}>
                    {languages.structure.scoring + " 1"}
                  </MenuItem>
                  {Object.keys(this.props.tournament.scoringTypes)
                    .sort((a, b) => a - b)
                    .map((key, i) => {
                      return (
                        <MenuItem key={key} value={key}>
                          {languages.structure.scoring +
                            " " +
                            (i + 2).toString()}
                        </MenuItem>
                      );
                    })}
                </Select>
                <FormHelperText>
                  {languages.structure.scoreTypeOverwriteWarning}
                </FormHelperText>
              </FormControl>
            )}

            {!this.props.bracket && (
              <FormControl style={{ marginTop: 20, width: "100%" }}>
                <InputLabel htmlFor="num-encounters">
                  {languages.structure.numEncounters}
                </InputLabel>
                <Select
                  value={this.props.numEncounters}
                  onChange={this.props.handleNumEncountersChange}
                  inputProps={{
                    name: "numEncounters",
                    id: "num-encounters",
                  }}
                  style={{ width: "100%" }}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                </Select>
                <FormHelperText>
                  {languages.formatString(
                    languages.structure.numEncountersDescription,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow
                  )}
                </FormHelperText>
              </FormControl>
            )}

            {!this.props.allowedToUpload ? (
              <div
                style={{
                  background: "rgb(236, 239, 241)",
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 30,
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.props.showSponsor}
                        onChange={this.props.handleShowSponsorChange}
                        color="primary"
                        name="showSponsor"
                        disabled={!this.props.allowedToUpload}
                      />
                    }
                    label={languages.structure.bracketSponsor}
                  />
                </FormGroup>
                <InfoIcon
                  style={{
                    height: 15,
                    width: 15,
                    top: 2,
                    position: "relative",
                  }}
                />
                {" " + languages.upgrade.upgradeTextExtraSponsor}
                <br />
                <Button
                  style={{ marginTop: 5 }}
                  variant="contained"
                  onClick={() => {
                    this.props.toggleUpgradeDialog(false);
                  }}
                  color="primary"
                  size="small"
                >
                  {languages.upgrade.seePackages}
                </Button>
              </div>
            ) : (
              <div>
                <FormGroup style={{ marginTop: 5 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.props.showSponsor}
                        onChange={this.props.handleShowSponsorChange}
                        color="primary"
                        name="showSponsor"
                        disabled={!this.props.allowedToUpload}
                      />
                    }
                    label={languages.structure.bracketLogo}
                  />
                </FormGroup>
                {this.props.showSponsor && (
                  <EditSponsorElement
                    tournament={this.props.tournament}
                    sponsorName={this.props.sponsorName}
                    sponsorLogoURL={this.props.sponsorLogoURL}
                    sponsorStorageRef={this.props.sponsorStorageRef}
                    handleDeleteSponsor={this.props.handleDeleteSponsor}
                    handleUploadStart={this.props.handleUploadStart}
                    handleProgress={this.props.handleProgress}
                    handleUploadError={this.props.handleUploadError}
                    handleUploadSuccess={this.props.handleUploadSuccess}
                    allowedToUpload={this.props.allowedToUpload}
                    handleSponsorNameChange={this.props.handleChange}
                    errorMessage={this.props.errorMessageSponsor}
                    isUploading={this.props.isUploadingSponsor}
                  />
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              disabled={!this.props.nameValid}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.bracket
                ? languages.general.change
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
